const SPACES = {
	LIST: 'NEWS_LIST',
	TAGS: 'TAGS',
	SELECTED_TAG: 'SELECTED_TAG',
};

export default SPACES;
